import React, { useState } from 'react'
import Styles from './Styles.module.css'
import SelectDropdown from '../../../../Components/Dropdown/SelectDropdown';
import closeImg from '../../../../Assets/images/store_close.png'
import deliverymanOfflineWithOrders from '../../../../Assets/images/deliveryman_offline_with_orders.png'
import deliverymanOnlineWithOrders from '../../../../Assets/images/deliveryman_online_with_orders.png'
import deliverymanOffline from '../../../../Assets/images/deliveryman_offline.png'
import deliverymanOnline from '../../../../Assets/images/deliveryman_online.png'
import CustomeCheckBox from '../../../../Components/CheckBox/checkBox';


function RightCard({ sx, tabs, setTab }) {
  const [locationState, setLocationState] = useState([
    {
      label:"Online",
      name:"online",
      ischecked:false,
      value:"Online",
      Icon:deliverymanOnline,
    },
    {
      label:"Offline",
      name:"offline",
      ischecked:false,
      value:"Offline",
      Icon:deliverymanOffline,
    },
    {
      label:"Online With Order",
      name:"OnlineWithOrder",
      ischecked:false,
      value:"Online With Order",
      Icon:deliverymanOnlineWithOrders,
    },
    {
      label:"Offline With Order",
      name:"OfflineWithOrder",
      ischecked:false,
      value:"Offline With Order",
      Icon:deliverymanOfflineWithOrders,
    }
  ]);

 const handleLocation = (e,i) => {
     const {name,value}= e.target
  //  console.log("name",name);
  //  console.log("value",value);
  const duplicatelocationState=[...locationState]
  duplicatelocationState[i].ischecked=!duplicatelocationState[i].ischecked
  setLocationState(duplicatelocationState)
  }
  return (
    <div style={sx ? sx : {}} className={[`${Styles.navContainer}`]}>
      <div className={[`${Styles.nav}`]}>
        {/* {tabs.map((t,i)=>(<button key={i} onClick={()=>handleClick(t,i)} className={t.isActive?[`${Styles.active} ${Styles.navItem}`]:[`${Styles.navItem}`]}>{t.tab}</button>))}        */}
        <div className="wrapper">
          <p className={Styles.filterLabel}>Country: </p>
          <SelectDropdown
            sx={{ width: "100%", height: "2.5rem", borderRadius: "3px", border: "1px solid var(--boder-color)" }}
            inputName="dispatch_filter"
            placeholder=""
            options={[{ name: "India", code: "India" }, { name: "Argentina", code: "Argentina" },]}
            handleFilter={(v) => { console.log("v", v); }}
          />
        </div>
        <div className="wrapper">
          <p className={Styles.filterLabel}>City: </p>
          <SelectDropdown
            sx={{ width: "100%", height: "2.5rem", borderRadius: "3px", border: "1px solid var(--boder-color)" }}
            inputName="dispatch_filter"
            placeholder=""
            options={[{ name: "Bilaspur", code: "Bilaspur" }, { name: "Korba", code: "Korba" },]}
            handleFilter={(v) => { console.log("v", v); }}
          />
        </div>
        
        {/* <div className="wrapper">
          <p className={Styles.filterLabel}>State: </p>          
          {locationState.map((loc,i)=>(
            <div key={i} className={Styles.checkBoxWrapper}>
            <div className={Styles.checkBox}>             
              <input className={Styles.checkBoxInput} type="checkbox" id={loc.name} name={loc.name} value={loc.value} checked={loc.ischecked} onChange={(e)=>handleLocation(e,i)} />
              <label htmlFor="storeBusinessOff" className="ml-2">{loc.label}</label>
            </div>
            <img src={loc.Icon} alt="storeBusinessOff"/>            
          </div>
        ))}         
        </div> */}
        <div className="wrapper">
          <p className={Styles.filterLabel}>State: </p>          
          {locationState.map((loc,i)=>(
            <div key={i} className={Styles.checkBoxWrapper}>
            <div className={Styles.checkBox}>             
              {/* <input className={Styles.checkBoxInput} type="checkbox" id={loc.name} name={loc.name} value={loc.value} checked={loc.ischecked} onChange={(e)=>handleLocation(e,i)} />
              <label htmlFor="storeBusinessOff" className="ml-2">{loc.label}</label> */}
              <CustomeCheckBox id={loc.name} name={loc.name} value={loc.value} checked={loc.ischecked} loc={loc} handleLocation={(e)=>handleLocation(e,i)} />
            </div>
            <img src={loc.Icon} alt="storeBusinessOff"/>            
          </div>
        ))}         
        </div>

     

      </div>

    </div>
  )
}

export default RightCard